import {API_URL, apiGet} from '../api'
import {ILeagueList} from './getLeagueList'
import {ApiRes} from '../../types/api'

export interface IShowLeagues {
    end_at: number
    id: string
    name: string
    show: number
    start_at: number
}

export interface IShowLeague {
    count: number
    leagues: ILeagueList[]
}

export const apiGetLeagueShow = async (): Promise<ApiRes<IShowLeague>> => {
    return await apiGet(API_URL, 'leagues/show')
}
